import common from './common.json'
import subscription from './subscription.json'
import bundle from './bundle.json'
import panel from './panel.json'
export default {common, panel, bundle, subscription };
